export { ConfirmDialogModule } from './confirm-dialog.module';
export { ConfirmDialog } from './confirm-dialog.component';
export * from './interfaces';
